import { Size } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Body from '@swf/components/StarsModal/components/Body';
import type { Dispatch } from '@swf/core/store';
import { BaseHeader, useWidgetTheme } from '@swf/poker';

import useClubMessageRequest from '../../Club/Announcements/hooks/useClubMessageRequest';

import {
  TXTCLI_Announcements,
  TXTCLI_Are_you_sure_you_want_to_delet_ELL_4,
  TXTCLI_Cancel,
  TXTCLI_Confirm_delete,
  TXTCLI_Delete
} from './DeleteAnnouncementPrompt.messages.json';
import styles from './DeleteAnnouncementPrompt.scss';

const DeleteAnnouncementPrompt: React.FC = () => {
  const {
    state: { clubId }
  } = useLocation<{
    clubId: string;
  }>();
  const [loading, setLoading] = useState(false);
  const { handleSubmit } = useClubMessageRequest({ clubId, setLoading });
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { className } = useWidgetTheme();

  const { modal } = useDispatch<Dispatch>();

  useEffect(() => {
    setStyle({
      overlayClassName: className,
      className: classNames(styles.modalContainer, styles.container),
      size: Size.SMALL,
      closeOnOverlayClick: true,
      closeOnEsc: true
    });
  }, [className, setStyle]);

  const handleClose = () => {
    modal.close();
  };

  const handleDelete = () => {
    handleSubmit({ announcement: '' });
    modal.close();
  };

  return (
    <>
      <BaseHeader
        headerClassName={styles.header}
        title={<Translation {...TXTCLI_Delete} />}
        subTitle={<Translation {...TXTCLI_Announcements} />}
      />
      <Body className={styles.body}>
        <p className={styles.text}>
          <Translation {...TXTCLI_Are_you_sure_you_want_to_delet_ELL_4} />
        </p>
        <div className={styles.bodyActionButtons}>
          <StarsButton
            className={styles.actionButton}
            variant="secondary"
            disabled={loading}
            onClick={handleClose}
            translation={TXTCLI_Cancel}
          />
          <StarsButton
            className={styles.actionButton}
            variant="primary"
            disabled={loading}
            onClick={handleDelete}
            translation={TXTCLI_Confirm_delete}
          />
        </div>
      </Body>
    </>
  );
};

export default DeleteAnnouncementPrompt;
